class CollectionFilters extends HTMLElement {
  constructor() {
    super();
  }

  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  connectedCallback() {
    this.filterTabs = Array.from(this.querySelectorAll("accordion-toggle"));
    this.filterOptions = this.querySelectorAll("input");
    this.minRange = this.querySelector("input[type='range'][data-min-value]");
    this.maxRange = this.querySelector("input[type='range'][data-max-value]");
    this.minValueDisplay = this.querySelector("[data-min-value-display]");
    this.maxValueDisplay = this.querySelector("[data-max-value-display]");

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleRangeInput = this.handleRangeInput.bind(this);

    this.filterOptions.forEach((option) => {
      option.addEventListener("change", this.handleFilterChange);
    });

    this.minRange.addEventListener("input", this.handleRangeInput);
    this.maxRange.addEventListener("input", this.handleRangeInput);
  }

  disconnectedCallback() {
    this.filterOptions.forEach((option) => {
      option.removeEventListener("change", this.handleFilterChange);
    });

    this.minRange.removeEventListener("input", this.handleRangeInput);
    this.maxRange.removeEventListener("input", this.handleRangeInput);
  }

  handleFilterChange(event) {
    const input = event.target;
    let url;

    if (input.dataset.addUrl || input.dataset.removeUrl) {
      url = new URL(
        input.checked ? input.dataset.addUrl : input.dataset.removeUrl,
        window.location.origin,
      );
    } else {
      url = new URL(location.href);

      url.searchParams.delete(this.minRange.dataset.param);
      url.searchParams.delete(this.maxRange.dataset.param);
      url.searchParams.set(this.minRange.dataset.param, this.minRange.value);
      url.searchParams.set(this.maxRange.dataset.param, this.maxRange.value);
    }

    url.searchParams.set("section_id", this.sectionId);

    fetch(url.toString())
      .then((response) => response.text())
      .then((html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        const openFilters = this.filterTabs
          .map((value, index) =>
            value.classList.contains("accordion--open") ? index : -1,
          )
          .filter((i) => i !== -1);

        openFilters.forEach((i) => {
          const currentFilter = tempDiv
            .querySelector(".collection-filters__content")
            .querySelectorAll("accordion-toggle")[i];

          currentFilter.classList.add("accordion--open");
        });

        document.querySelector(".collection-inner").innerHTML =
          tempDiv.querySelector(".collection-inner").innerHTML;

        url.searchParams.delete("section_id");
        window.history.pushState({}, "", url.toString());
      });
  }

  handleRangeInput(event) {
    const value = parseInt(event.currentTarget.value);
    const isMinRange = event.currentTarget.hasAttribute("data-min-value");

    if (isMinRange) {
      const maxValue = parseInt(this.maxRange.value);
      if (value >= maxValue) {
        event.currentTarget.value = maxValue - 10;
      }

      if (this.minValueDisplay) {
        this.minValueDisplay.textContent = this.formatValue(
          event.currentTarget.value,
        );
      }
    } else {
      const minValue = parseInt(this.minRange.value);
      if (value <= minValue) {
        event.currentTarget.value = minValue + 10;
      }

      if (this.maxValueDisplay) {
        this.maxValueDisplay.textContent = this.formatValue(
          event.currentTarget.value,
        );
      }
    }
  }

  formatValue(value) {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  }
}

customElements.define("collection-filters", CollectionFilters);

// ACCORDION
class AccordionToggle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = this.querySelector(".accordion__header");
    this.content = this.querySelector(".accordion__content");

    this.handleClick = this.handleClick.bind(this);
    this.header.addEventListener("click", this.handleClick);

    this.addMaxHeight();
  }

  disconnectedCallback() {
    this.header.removeEventListener("click", this.handleClick);
  }

  handleClick() {
    this.classList.toggle("accordion--open");
  }

  addMaxHeight() {
    this.style.setProperty(
      "--accordion-content-height",
      this.content.scrollHeight + "px",
    );
  }
}

customElements.define("accordion-toggle", AccordionToggle);

// SORTING DROPDOWN
class CollectionSort extends HTMLElement {
  constructor() {
    super();
    this.select = null;
    this.isOpen = false;

    this.onDocumentClick = this.onDocumentClick.bind(this);
  }

  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  connectedCallback() {
    this.select = this.querySelector("#sort-by-select");

    if (this.select) {
      this.select.addEventListener("change", this.onSortChange.bind(this));
      this.select.addEventListener("mousedown", this.onToggle.bind(this));
    }
  }

  disconnectedCallback() {
    if (this.select) {
      this.select.removeEventListener("change", this.onSortChange);
      this.select.removeEventListener("mousedown", this.onToggle);
    }
    document.removeEventListener("click", this.onDocumentClick);
  }

  onSortChange(event) {
    const newSort = event.target.value;
    const url = new URL(window.location.href);

    url.searchParams.set("sort_by", newSort);
    url.searchParams.set("section_id", this.sectionId);

    fetch(url.toString())
      .then((res) => res.text())
      .then((html) => {
        const temp = document.createElement("div");
        temp.innerHTML = html;

        document.querySelector(".collection-inner").innerHTML =
          temp.querySelector(".collection-inner").innerHTML;

        url.searchParams.delete("section_id");
        window.history.replaceState({}, "", url.toString());
      });
  }

  onToggle(event) {
    event.stopPropagation();

    if (this.isOpen) this.close();
    else this.open();
  }

  open() {
    this.classList.add("open");
    this.isOpen = true;

    document.addEventListener("click", this.onDocumentClick);
  }

  close() {
    this.classList.remove("open");
    this.isOpen = false;

    document.removeEventListener("click", this.onDocumentClick);
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }
}

customElements.define("collection-sort", CollectionSort);

// QUICK VIEW POPUP
class QuickAtcPopup extends HTMLElement {
  connectedCallback() {
    this.popup = document.getElementById("quick-atc-popup");
    this.overlay = this.popup.querySelector(".quick-atc-overlay");
    this.imageEl = this.popup.querySelector(".quick-atc-image");
    this.titleEl = this.popup.querySelector(".quick-atc-title");
    this.variantContainer = this.popup.querySelector(".quick-atc-variants");
    this.addBtn = this.popup.querySelector(".quick-atc-add");
    this.continueBtn = this.popup.querySelector(".quick-atc-continue");
    this.priceEl = this.popup.querySelector(".quick-atc-price");
    this.comparePriceEl = this.popup.querySelector(".quick-atc-compare-price");

    this.registerEvents();
  }

  registerEvents() {
    document.addEventListener("click", async (e) => {
      const trigger = e.target.closest(".quick-atc-trigger");
      if (!trigger) return;

      const handle = trigger.getAttribute("data-product-handle");
      const rating = trigger.getAttribute("data-product-rating") || 0;

      await this.loadProduct(handle);
      this.updateRating(rating);
      this.show();
    });

    this.overlay.addEventListener("click", () => this.hide());
    this.continueBtn.addEventListener("click", () => this.hide());

    this.addBtn.addEventListener("click", () => {
      const variantId = this.selectedVariant;

      if (!variantId) {
        console.error("No variant selected!");
        return;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((res) => res.json())
        .then((item) => {
          const btnImgSrc = this.addBtn.getAttribute("data-product-image");

          if (btnImgSrc) {
            this.flyToCartFromButton(
              btnImgSrc,
              this.addBtn,
              ".header-actions__cart-icon",
            );
          }

          this.hide();

          document.dispatchEvent(
            new CustomEvent("cart:update", {
              bubbles: true,
              detail: {
                data: {
                  itemCount: item.quantity,
                  source: "product-form-component",
                },
              },
            }),
          );
        })
        .catch((err) => console.error("Add to cart error:", err));
    });
  }

  updateRating(rating) {
    rating = Number(rating);

    const ratingText = this.popup.querySelector(".quick-view-rating");
    if (ratingText) ratingText.textContent = rating.toFixed(1);

    const rounded = Math.round(rating);
    const starWrapper = this.popup.querySelector(".ecom-star-rating");
    if (!starWrapper) return;

    let html = "";
    for (let i = 1; i <= 5; i++) {
      html += `
        <svg width="19" height="18">
          <path d="M9.03516 0L11.3972 6.24897L18.0702 6.56434L12.857 10.7418L14.6191 17.1857L9.03516 13.5185L3.4512 17.1857L5.21334 10.7418L0.000119209 6.56434L6.67314 6.24897L9.03516 0Z"
          fill="${i <= rounded ? "#0086BD" : "gray"}"/>
        </svg>`;
    }

    starWrapper.innerHTML = html;
  }

  async loadProduct(handle) {
    const res = await fetch(`/products/${handle}.js`);
    const product = await res.json();

    console.log(product);

    this.productData = product;
    this.imageEl.src = product.images[0];
    this.addBtn.setAttribute("data-product-image", product.images[0]);
    this.titleEl.textContent = product.title;

    const groupsContainer = this.popup.querySelector(
      ".quick-atc-option-groups",
    );

    if (!groupsContainer) {
      console.error("Missing .quick-atc-option-groups in HTML!");
      return;
    }

    groupsContainer.innerHTML = "";

    const variantWrapper = groupsContainer.closest(
      ".quick-atc-variant-wrapper",
    );
    variantWrapper.style.display =
      product.variants.length === 1 ? "none" : "block";

    product.options.forEach((optionObj, optionIndex) => {
      const group = document.createElement("div");
      group.className = "quick-atc-option-group";

      group.innerHTML = `
    <p class="quick-atc-option-title" data-option-index="${optionIndex}">
      ${optionObj.name}: <span class="selected-value"></span>
    </p>
    <div class="quick-atc-options" data-option-index="${optionIndex}"></div>
  `;

      groupsContainer.appendChild(group);

      const optionsWrapper = group.querySelector(".quick-atc-options");

      const values = [
        ...new Set(product.variants.map((v) => v.options[optionIndex])),
      ];

      values.forEach((value, idx) => {
        const btn = document.createElement("button");
        btn.className = "quick-atc-option-btn";
        btn.dataset.value = value;
        btn.dataset.optionIndex = optionIndex;
        if (idx === 0) btn.classList.add("active");

        btn.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <circle cx="12.5" cy="12.5" r="12.25" fill="#D9D9D9" stroke="black" stroke-width="0.5"/>
          </svg>
          <span>${value}</span>
        `;
        optionsWrapper.appendChild(btn);
      });

      // Default selected value
      const titleEl = group.querySelector(".selected-value");
      titleEl.textContent = values[0];
    });

    // Handle click on option buttons
    groupsContainer.querySelectorAll(".quick-atc-option-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const index = Number(btn.dataset.optionIndex);
        const wrapper = btn.closest(".quick-atc-options");

        wrapper
          .querySelectorAll("button")
          .forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");

        const selectedOptions = [];
        groupsContainer
          .querySelectorAll(".quick-atc-options")
          .forEach((grp, idx) => {
            const active = grp.querySelector(".active");
            selectedOptions[idx] = active.dataset.value;
          });

        const variant = product.variants.find((v) =>
          v.options.every((val, i) => val === selectedOptions[i]),
        );

        // Update the option title selected value
        const titleSpan = groupsContainer.querySelector(
          `.quick-atc-option-title[data-option-index="${index}"] .selected-value`,
        );
        titleSpan.textContent = btn.dataset.value;

        if (variant) {
          this.updatePrice(variant);

          this.updateAddButton(variant);
          this.selectedVariant = variant.id;
        }
      });
    });

    groupsContainer.querySelectorAll(".quick-atc-option-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const index = Number(btn.dataset.optionIndex);
        const wrapper = btn.closest(".quick-atc-options");

        wrapper
          .querySelectorAll("button")
          .forEach((b) => b.classList.remove("active"));

        btn.classList.add("active");

        const selectedOptions = [];
        groupsContainer
          .querySelectorAll(".quick-atc-options")
          .forEach((grp, idx) => {
            const active = grp.querySelector(".active");
            selectedOptions[idx] = active.dataset.value;
          });

        const variant = product.variants.find((v) =>
          v.options.every((val, i) => val === selectedOptions[i]),
        );

        if (variant) {
          this.updatePrice(variant);
          this.updateAddButton(variant);
          this.selectedVariant = variant.id;
        }
      });
    });

    const defaultVariant = product.variants[0];
    this.updatePrice(defaultVariant);
    this.updateAddButton(defaultVariant);
    this.selectedVariant = defaultVariant.id;
  }

  updatePrice(variant) {
    const formatMoney = (cents) => {
      if (!window.ShopifyMoneyFormat) {
        return (cents / 100).toFixed(2);
      }
      const amount = (cents / 100).toFixed(2);
      return window.ShopifyMoneyFormat.replace("{{amount}}", amount);
    };

    this.priceEl.textContent = formatMoney(variant.price);

    if (variant.compare_at_price > variant.price) {
      this.comparePriceEl.textContent = formatMoney(variant.compare_at_price);
      this.comparePriceEl.style.display = "inline";
    } else {
      this.comparePriceEl.style.display = "none";
    }
  }

  updateAddButton(variant) {
    const label = this.addBtn.querySelector(".modal-atc-label");

    if (variant.available) {
      this.addBtn.disabled = false;
      this.addBtn.classList.remove("disabled");
      label.textContent = "Add To Cart";
    } else {
      this.addBtn.disabled = true;
      this.addBtn.classList.add("disabled");
      label.textContent = "Sold Out";
    }
  }

  show() {
    this.popup.classList.add("active");
  }

  hide() {
    this.popup.classList.remove("active");
  }

  flyToCartFromButton(imgSrc, buttonEl, cartSelector) {
    const cartIcon = document.querySelector(cartSelector);
    if (!cartIcon) return;

    const flyImg = document.createElement("img");
    flyImg.src = imgSrc;
    flyImg.style.position = "fixed";
    flyImg.style.width = "40px";
    flyImg.style.height = "40px";
    flyImg.style.borderRadius = "100px";
    flyImg.style.pointerEvents = "none";
    flyImg.style.zIndex = "9999";

    const startRect = buttonEl.getBoundingClientRect();
    flyImg.style.left = `${startRect.left + startRect.width / 2 - 30}px`;
    flyImg.style.top = `${startRect.top + startRect.height / 2 - 30}px`;

    document.body.appendChild(flyImg);

    const endRect = cartIcon.getBoundingClientRect();
    const deltaX =
      endRect.left + endRect.width / 2 - (startRect.left + startRect.width / 2);
    const deltaY =
      endRect.top + endRect.height / 2 - (startRect.top + startRect.height / 2);

    flyImg.style.transition =
      "transform 0.8s cubic-bezier(.07,.44,.9,.49), opacity 1.2s";

    requestAnimationFrame(() => {
      flyImg.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.2)`;
      flyImg.style.opacity = "0";
    });

    flyImg.addEventListener("transitionend", () => flyImg.remove());
  }
}

customElements.define("quick-atc-popup-js", QuickAtcPopup);

// COLLECTION ADD TO CART
// Use delegation so buttons still work after recommendations HTML is swapped in
// (Customers Also Bought / feat-collection fetches cards after connectedCallback).
class CollectionAtc extends HTMLElement {
  connectedCallback() {
    if (this._delegated) return;
    this._delegated = true;
    this._onClick = this.onClick.bind(this);
    this.addEventListener("click", this._onClick);
  }

  disconnectedCallback() {
    if (!this._delegated) return;
    this.removeEventListener("click", this._onClick);
    this._delegated = false;
  }

  async onClick(e) {
    const btn = e.target.closest(".collection-atc");
    if (!btn || !this.contains(btn) || btn.disabled) return;

    e.preventDefault();

    const productEl = btn.closest(".collection-product");
    const imgEl = productEl?.querySelector(".collection-product__image");
    const handle =
      imgEl?.dataset.productHandle || btn.dataset.productHandle || "";
    const imgSrc = imgEl?.src || btn.dataset.productImage || "";

    if (!handle) return;

    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();
      const variantId = product.variants[0].id;

      if (imgSrc) {
        this.flyToCart(imgSrc, btn, ".header-actions__cart-icon");
      }

      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      const item = await addRes.json();

      document.dispatchEvent(
        new CustomEvent("cart:update", {
          bubbles: true,
          detail: {
            data: {
              itemCount: item.quantity,
              source: "product-form-component",
            },
          },
        }),
      );
    } catch (err) {
      console.error("Add to cart error:", err);
    }
  }

  flyToCart(imgSrc, buttonEl, cartSelector) {
    const cartIcon = document.querySelector(cartSelector);
    if (!cartIcon) return;

    const flyImg = document.createElement("img");
    flyImg.src = imgSrc;
    flyImg.style.position = "fixed";
    flyImg.style.width = "60px";
    flyImg.style.height = "60px";
    flyImg.style.borderRadius = "100px";
    flyImg.style.pointerEvents = "none";
    flyImg.style.zIndex = "9999";

    const startRect = buttonEl.getBoundingClientRect();
    flyImg.style.left = `${startRect.left + startRect.width / 2 - 30}px`;
    flyImg.style.top = `${startRect.top + startRect.height / 2 - 30}px`;

    document.body.appendChild(flyImg);

    const endRect = cartIcon.getBoundingClientRect();
    const deltaX =
      endRect.left + endRect.width / 2 - (startRect.left + startRect.width / 2);
    const deltaY =
      endRect.top + endRect.height / 2 - (startRect.top + startRect.height / 2);

    flyImg.style.transition =
      "transform 0.8s cubic-bezier(.07,.44,.9,.49), opacity 1.2s";

    requestAnimationFrame(() => {
      flyImg.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.2)`;
      flyImg.style.opacity = "0";
    });

    flyImg.addEventListener("transitionend", () => flyImg.remove());
  }
}

customElements.define("collection-atc-js", CollectionAtc);
